import React, { useEffect, useState } from "react";
import BASE_URL from "../../config";

export default function Footer() {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    fetch(`${BASE_URL}/api/getContact.php`)
      .then((res) => res.json())
      .then((data) => setContacts(data));
  }, []);

  return (
    <footer className="modern-footer">
      <div className="footer-overlay"></div>

      <div className="footer-top">
        <div className="footer-brand">
          <h2>
            શ્રી ગૃહલક્ષ્મી અર્બન કો.ઓપ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી
            લી.
          </h2>

          <p>
            મહિલાઓના આર્થિક સશક્તિકરણ માટે બચત, લોન અને નાણાકીય સેવાઓ પ્રદાન
            કરતી વિશ્વસનીય સંસ્થા.
          </p>
        </div>
      </div>

      <div className="footer-grid">
        {/* Links */}
        <div className="footer-card">
          <h3>અમારી સેવાઓ</h3>

          <a href="/#bachat">બચત યોજના</a>
          <a href="/#fd">ફિક્સ ડિપોઝિટ યોજના</a>
          <a href="/#insurance">વીમા યોજના</a>
          <a href="/#loan">લોન સુવિધા</a>
        </div>
        <div className="footer-card">
          <h3>ઝડપી લિંક્સ</h3>

          <a href="/">હોમ</a>
          <a href="/about">અમારા વિશે</a>
          <a href="/gallery">પ્રવૃત્તિઓ</a>
          <a href="/join">સંપર્ક</a>
        </div>
        <div className="footer-card">
          {contacts[0] && (
            <>
              <h3>{contacts[0].office_name}</h3>
              <p>{contacts[0].address}</p>
              <p>{contacts[0].phone1}</p>
            </>
          )}
        </div>
        {/* Branches */}
        <div className="footer-card">
          <h3>અમારી શાખાઓ</h3>

          {contacts.slice(1, 6).map((item) => (
            <div key={item.id} className="branch-row">
              <strong>{item.office_name}</strong>
              <span>{item.phone1}</span>
            </div>
          ))}
        </div>

        {/* Timing */}
        <div className="footer-card">
          <h3>કામકાજ નો સમય</h3>

          <p>{contacts[0]?.timing}</p>

          <p>બીજા તથા ચોથા શનિવારે રજા રહેશે.</p>
        </div>

        {/* Contact */}
      </div>

      <div className="footer-bottom">
        <p></p>© {new Date().getFullYear()} શ્રી ગૃહલક્ષ્મી અર્બન કો.ઓપ.
        થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી લી.
        <p style={{ color: "white" }}>
          Develpoed By:{" "}
          <a
            href="https://lifetimeinfotech.in/"
            style={{ color: "rgb(149, 187, 209)" }}
          >
            Lifetimeinfotech.in
          </a>
        </p>
      </div>
    </footer>
  );
}
